<template>
  <v-container class="" id="search-container">
    <!-- *RPD Forms  Appv 0.91
* Copyright (c) 2025, Blue Cover Six LLC . All rights reserved.
Code licensed under contract To Reno Police Department / City of Reno, in perpetuity -->
<p>If no search criteria are entered, all records will be returned.</p>
    <v-form ref="form" dark v-model="valid" lazy-validation>
      <v-container fluid id="form-container">
        <v-row dense>
          <v-col cols="12" md="2">
            <v-text-field
              color="white"
              dark
              maxlength="8"
              v-model="sterm.regnum"
              :counter="8"
              type="number"
              label="Reference  #"
            
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              color="white"
              dark
              maxlength="60"
              v-model="sterm.fname"
              :counter="60"
              :rules="rule60"
              label="First Name"
            
            ></v-text-field
          ></v-col>
          <v-col cols="12" md="6">
            <v-text-field
              color="white"
              dark
              maxlength="60"
              v-model="sterm.lname"
              :counter="60"
              :rules="rule60"
              label="Last Name"
          
            ></v-text-field
          ></v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6">
            <date_field label="DOB" v-model="sterm.dob"></date_field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              color="white"
              dark
              maxlength="120"
              v-model="sterm.email"
              :counter="120"
              :rules="emailRules"
              label="Email"
           
            ></v-text-field
          ></v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              v-mask="'###-###-####'"
              color="white"
              dark
              maxlength="12"
              v-model="sterm.phone"
              :counter="12"
              label="Phone"
       
              placeholder="###-###-####"
            ></v-text-field
          ></v-col>
          <v-col cols="12" md="6">
            <v-text-field
              color="white"
              dark
              maxlength="120"
              v-model="sterm.address"
              :counter="120"
              :rules="rule120"
              label="Address"
           
            ></v-text-field
          ></v-col>
        </v-row>
        <div class="d-flex justify-center">
          <p>Result must contain SOME search terms or ALL search terms.</p>
        </div>
        <div class="d-flex justify-center">
          <label class="mr-1">SOME</label>
          <v-switch
            class="ma-0 pa-0"
            id="swith"
            dark
            color="white"
            v-model="sterm.all"
          ></v-switch>
          <label class="ml-1">ALL</label>
        </div>
        <v-row dense>
          <v-col cols="12" md="3">
            <v-btn
              id="btn-clear"
              class="btn-size"
              color="grey darken-1"
              @click="search"
            >
              <v-icon>$magnify</v-icon>SEARCH NOW
            </v-btn>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn class="btn-size" color="grey darken-1" @click="reset">
              CLEAR</v-btn
            ></v-col
          ></v-row
        >
      </v-container>
    </v-form>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
@media (min-width: 0px) {
  /* Vue 2 + Vue CLI recommended */
  ::v-deep .v-text-field input[type="number"]::-webkit-outer-spin-button,
  ::v-deep .v-text-field input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::v-deep .v-text-field input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }

  >>> .v-text-field input[type="number"] {
    appearance: textfield;
  } /* legacy */

  .btn-size {
    width: 100%;
  }
}

/* Breakpoint: 768px and up */
@media (min-width: 768px) {
  #btn-clear {
    margin-left: 24px;
  }
  .btn-size {
    width: auto;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import date_field from "./date_field.vue";
export default {
  name: "search",
  mixins: [bus_common],
  components: { date_field },
  props: ["update_search"],
  data() {
    return {
      valid: true,
      show_edit_label: false,
      sterm: {
        regnum: "",
        fname: "",
        lname: "",
        email: "",
        dob: null,
        address: "",
        phone: "",
        all: false,
      },
      rule60: [

        (v) => (v && v.length <= 60) || "Name must be less than 60 characters",
      ],
      rule120: [
  
        (v) =>
          (v && v.length <= 120) || "Name must be less than 120 characters",
      ],
      email: "",
      emailRules: [

        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [
   
        (v) => /^775-\d{3}-\d{4}$/.test(v) || "Phone must be valid",
      ],
      phoneRules2: [
        (v) =>
          !v ||
          /^\d{3}-\d{3}-\d{4}$/.test(v.trim()) ||
          "Phone must be valid (###-###-####)",
      ],
    };
  },
  watch: {
    update_search: function () {
      if (this.update_search != null) {
        this.search();
      }
    },
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    },
search() {
  this.show_loader(true);

  var formIn = {};
  formIn.email = this.$store.state.user.email;
  formIn.token = this.$store.state.user.token;
  formIn.sterm = this.mno(this.sterm);

  console.log("DOB:", formIn.sterm.dob);
  console.log("REGNUM before parse:", formIn.sterm.regnum);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let dobInput = formIn.sterm.dob;

  if (dobInput === null || dobInput === "") {
    formIn.sterm.dob = new Date(1900, 0, 1);
  } else {
    let dob = new Date(dobInput);

    if (isNaN(dob.getTime())) {
      formIn.sterm.dob = new Date(1900, 0, 1);
    } else {
      dob.setHours(0, 0, 0, 0);

      if (dob.getTime() === today.getTime()) {
        formIn.sterm.dob = new Date(1900, 0, 1);
      }
    }
  }

    if (
      formIn.sterm.all === null ||
      formIn.sterm.all === "" ||
      typeof formIn.sterm.all === "undefined"
    ) {
         formIn.sterm.all = false;
    } else if (formIn.sterm.all === true || formIn.sterm.all === "true") {
         formIn.sterm.all = true;
    } else if (formIn.sterm.all === false || formIn.sterm.all === "false") {
         formIn.sterm.all = false;
    } else {
         formIn.sterm.all = false;
    }

  // Safely handle regnum
  if (
    formIn.sterm.regnum === null ||
    formIn.sterm.regnum === "" ||
    typeof formIn.sterm.regnum === "undefined"
  ) {
    formIn.sterm.regnum = 0;
  } else {
    let parsedRegnum = parseInt(formIn.sterm.regnum, 10);

    if (isNaN(parsedRegnum)) {
      formIn.sterm.regnum = 0;
    } else {
      formIn.sterm.regnum = parsedRegnum;
    }
  }

  console.log("REGNUM after parse:", formIn.sterm.regnum);

  formIn.apiname = "search";

  this.$store
    .dispatch("anyapi", formIn)
    .then((data) => {
      this.show_loader(false);

      if (data.length == 0) {
        this.swall_it(
          "Search Status",
          "No results were found for your search criteria. Please change your criteria and try again.",
          "warning",
          null,
          null
        );
        return true;
      }

      this.$emit("search_done", data);
    })
    .catch((msg) => {
      this.show_loader(false);
      this.swall_it("Error search", msg.msg, "error", null, null);
    });
},
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
